<div class="loader-container" *ngIf="isLoading">
	<div class="loader"></div>
  </div>

    
  <div class="app-view-container container" [class.margin-top-220px]="isAddFormShow" *ngIf="!isLoading">
	
  <!-------- Student View ---------------------->
	<div >
		<!-- <div class="d-flex app-paging">
			<p *ngFor="let app of apps; let i = index"
			class="cursor-pointer content-index"
			[ngClass]="{'active': selectedAppContent === i}"
			(click)="showContent(i)">
			{{i + 1}}
		 </p>
		  </div> -->
		 
	  <div *ngFor="let app of apps; let i = index">
		
		<div class="app-section student" id="target" *ngIf="selectedAppContent ===i ">
			<li class="nav-item lms-icon">
				<a class="lms-fullscreen apptogglefullscreen" id="lms-fullscreen"
				  (click)="ToggleClass()"><i class=" {{toggleClass}} font-medium-3"></i></a>
			  </li>
			<div class="col d-flex align-items-center title-btn-wrap" >
			<div class="course-titlee">
			  <div class="d-flex justify-content-between">
				<div class="app-title">
				  <h4  class="app-title-h4">
					{{app?.title}}
				  </h4> 
				</div>
			  </div>
			</div>
			
			<div class="submit-btn">
			  <button *ngIf="isSubmitted !==true && app?.app_tag[0]?.displayname === 'Assignment'" class="btn btn-outline-primary" (click)="openModalForAssignment(myModalContent,user.id,app?._id,courseId,topicId)">Submit</button>
			  <p class="badge bg-light-success" *ngIf="isSubmitted ===true">Submitted</p>
			</div>
			
		  </div>
		  <div *ngIf="app?.type === 'image'">
			<!-- Display image content -->
			<img width="100%" [src]="s3MediaUrl+app?.content" alt="Image" />
		  </div>
		  <div *ngIf="app?.type === 'video'&&!app.isurl_link">
			<!-- Display video content -->
			<video width="100%" [src]="s3MediaUrl+app?.content" controls></video>
		  </div>
		  <div *ngIf="app?.type === 'video'&&app.isurl_link ">
			<!-- Display video content -->
			<!-- <div [innerHTML]="this.sanitizedUrl"></div> -->
			<div [innerHTML]="app.url_link | safeHtml"></div>
			<div *ngIf="app.aws_s3_file_url">
				<video width="100%" [src]="app.aws_s3_file_url" controls></video>
			  </div>
			 <!-- {{formatHtmlapp?.url_link }} -->
		  </div>
		  <div *ngIf="app?.type === 'text'">
			<!-- Display markdown text content -->
			<div class="cstm-content" [innerHTML]="app?.content"></div>
		  </div>
	  
			<div class="row p-2" *ngIf=" user.roles ==='student'">
			  <div class="btn btn-outline-primary ml-2" *ngFor="let resource of app.resources">
				<a [href]="s3MediaUrl+resource.documents" target="_blank">{{resource.content}}</a>
			  </div>
			  <!-- <div class="col-xl-3 col-lg-6 col-12" *ngFor="let resource of app.resources">
				<div class="card">
				  <div class="card-content">
					<div class="card-body">
					  <div class="media">
						<div class="media-body text-left">
						  <h3 class="mb-1 danger">{{resource}}</h3>
						  <span></span>
						</div>
						<div class="media-right align-self-center">
						  <i class="fa fa-x cursor danger font-large-1 float-right"></i>
						</div>
					  </div>
					</div>
				  </div>
				</div>
			  </div> -->
			</div>
		</div>
	  </div>
	  <div class="app-btns-container" *ngIf="apps.length == 0 && topicId && !isLoading">
		Data not found!
	  </div>
	</div>
   
  </div>

  <div class="col-md-12 fix-bottom">
	<div id="bc_wrapper">
		<span class="section_bc text-capitalize" *ngIf="activeCourseName">&nbsp;&nbsp;{{ activeCourseName }} &nbsp;</span>
		<!-- <span class="section_bc text-capitalize" *ngIf="activeSectionName">&gt;&gt; {{ activeSectionName }}</span>
		<span class="chapter_bc text-capitalize" *ngIf="activeChapterName">&gt;&gt; {{ activeChapterName }}</span> -->
		<span class="topic_bc blue_c text-capitalize" *ngIf="activeTopicName">&gt;&nbsp; {{ activeTopicName }}&nbsp;</span>
		<span class="pre-nxt-btn">
			<i placement="top" ngbTooltip="previous button" class="ft-chevrons-left text-primary cursor-pointer" (click)="onPrevious()"></i> ||
			<i placement="top" ngbTooltip="next button" class="ft-chevrons-right text-primary cursor-pointer" (click)="onNext()"></i>
		</span>
	</div>
	<div class="d-flex app-paging" *ngIf="activeTopicName">
		<p *ngFor="let app of apps; let i = index"
		class="cursor-pointer content-index"
		[ngClass]="{'active': selectedAppContent === i}"
		(click)="showContent(i)">
		{{i + 1}}
	 </p>
	  </div>
	  <footer class="footer">
		<p class="copyright clearfix text-muted m-0">
		  Copyright &copy; {{currentDate | date: 'yyyy'}} <a id="pixinventLink" target="_blank"
			href="https://www.meander.software/">MEANDER SOFTWARE</a>
		  <span class="d-none d-sm-inline-block">, All rights reserved.</span>
		</p>
	  </footer>
  </div>



  <!-- <div class="video-container">
	<video width="100%" height="100%" controls>
	  <source src="myvideo.mp4" type="video/mp4">
	  Your browser does not support the video tag.
	</video>
	<div class="video-controls">
	  <i class="icon-volume-up"></i>
	</div>
  </div> -->
  <app-lms-content-editior #modalRef [appType]="appType" (closeModal)="closeModel()" [selectedApp]="selectedApp"
	[courseId]="courseId" [topicId]="topicId"></app-lms-content-editior>
  
  <!------------- Assignment Popup --------------------------------------->
  <div>
	<ng-template #myModalContent>
	  <div class="modal-header">
		<h4 class="modal-title">Assignment</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<div class="form-group">
		  <label>Description</label>
		  <textarea class="form-control" [(ngModel)]="assignment_model.notes" [ngModelOptions]="{standalone: true}" placeholder="Enter description" name="notes" id="notes" cols="30" rows="2"></textarea>
		</div>
		<div class="form-group">
		  <label>Teacher Notes</label>
		  <textarea class="form-control" [(ngModel)]="assignment_model.admin_notes" [ngModelOptions]="{standalone: true}" name="admin_notes" id="admin_notes" cols="30" rows="2"  placeholder="Enter teacher notes" ></textarea>
		</div>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
		<button type="button" class="btn btn-primary" (click)="assignmentSubmit()">Save changes</button>
	  </div>
	</ng-template>
  </div>
  
  <!----- Update Popup --------------->
  
  <div>
	<ng-template #myModalContentUpdate>
	  <div class="modal-header">
		<h4 class="modal-title">{{modalFor}} Update</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<div class="form-group" *ngIf="this.lms_model.description">
		  <div class="card-header">
			<h5 class="card-title">Description:</h5>
			<textarea name="Content Scripts" class="form-control" id="textarea-input" [(ngModel)]="lms_model.description"  cols="30" rows="2"></textarea>
		  </div>
		</div>
		<div class="form-group" *ngIf="this.lms_model.content_scripts">
		  <div class="card-header">
			<h5 class="card-title">Content Scripts:</h5>
			<textarea name="Content Scripts" class="form-control" id="textarea-input" [(ngModel)]="lms_model.content_scripts"  cols="30" rows="2"></textarea>
		  </div>
		</div>
		<div class="form-group" *ngIf="this.lms_model.teachers_notes">
		  <div class="card-header">
			<h5 class="card-title">Teachers Notes:</h5>
			<textarea name="Teachers Notes" class="form-control" id="textarea-input" [(ngModel)]="lms_model.teachers_notes" cols="30" rows="2"></textarea>
		  </div>
		</div>
		<div class="card-header" *ngIf="selected_resources">
		  <h5 class="card-title">Resources:</h5>
			<ng-select 
			[items]="resources_list"
			bindLabel="content"
			bindValue="id"
			[multiple]="true"
			[closeOnSelect]="false"
			placeholder="Select Resource"
			[(ngModel)]="selected_resources"
			[ngModelOptions]="{ standalone: true }"
			(change)="getResourceId($event)">
		  </ng-select>
		</div>
		<div class="card-header" *ngIf="selected_app_tag">
		  <h5 class="card-title">App Tag:</h5>
		  <ng-select 
			[items]="app_tags_list"
			bindLabel="displayname"
			bindValue="_id"
			[closeOnSelect]="false"
			placeholder="Select App Tag"
			[(ngModel)]="selected_app_tag"
			[ngModelOptions]="{ standalone: true }"
			(change)="getAppTagId($event)">
		  </ng-select>
		</div>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
		<button type="button" class="btn btn-primary" (click)="updateContent()">Save</button>
	  </div>
	</ng-template>
  </div>